export const validateZero = (param) => param || param === 0;
